export const environment = {
	IsProduction: true,
	serviceWorkerEnabled: true,
	IsHero: false,
	environment: 'prod',
	launchDarklyClientId: '664590c02c638010dc55095f',
	oneTimeTokenName: 'fenixOneTimeToken',
	homepage: 'https://analyzer.testtools.scania.com/',
	redirectUrl: 'https://testtools.scania.com/login',
	jiraBaseUrl: 'https://jiratoolchain.collaborationlayer-traton.com/browse/',
	requirementsUrl: 'https://polarion.scania.com/polarion/#/',
	defaultTestToolOwnerUid: '7F7FF914-440D-4BB9-B64A-9943569DA8E1',
	analyticsAppId: 'analyzer',
	analyticsSdkScriptUrl: 'https://webanalytics-sdk.testtools.prod.gf.aws.scania.com/analytics.sdk.js',
	breakPoint: 960,
	reportsUrl: 'https://reports.tms.scania.com/',
	fenixReportsUrl: 'https://reports.testtools.scania.com/',
};

export const Config = {
	colaConfig: {
		disabled: false,
		redirectUrl: 'https://testtools.scania.com/login',
	},
};

export const AbstractionLayerConfig = {
	stagingUri: 'https://db2guulfzfdl7gbbaqsxuq7fku.appsync-api.eu-north-1.amazonaws.com/graphql',
	releaseUri: 'https://gcjpczafmrcdpjuxuj3yeloujm.appsync-api.eu-north-1.amazonaws.com/graphql',
	realtimeStagingUri: 'wss://db2guulfzfdl7gbbaqsxuq7fku.appsync-realtime-api.eu-north-1.amazonaws.com/graphql',
	realtimeReleaseUri: 'wss://gcjpczafmrcdpjuxuj3yeloujm.appsync-realtime-api.eu-north-1.amazonaws.com/graphql',
};

export const authentication = {
	authLayerStagingUrl: 'https://fprf6glbwvdxjotfqptkz7zeg4.appsync-api.eu-north-1.amazonaws.com/graphql',
	authLayerReleaseUrl: 'https://7t7hgxyzyzb6hi5fevn2dwl3ce.appsync-api.eu-north-1.amazonaws.com/graphql',
};

export const bedrock = {
	// Injected at build time from GitLab CI
	lambdaUrl: 'https://6opeyxojilnkwzbkrpnufro63m0yngtl.lambda-url.eu-north-1.on.aws/',
	cloudFrontSecret: 'tCOtsaOdg4jw/f36STBdJ4ZqFTs+/P9UhUJTGZTFVao=',
};

export const FenixExport = {
	baseExecutorUrl: 'https://executor.testtools.scania.com/testrun-execution',
	baseResultsUrl: 'https://results.testtools.scania.com/#/testresult/testrun',
};

export const menuUrls = {
	supportUrl:
		'https://teams.microsoft.com/l/team/19%3Af0563924f10948e29b24c3580bfa34a6%40thread.tacv2/conversations?groupId=34884b53-40a8-4388-b61a-a801abce4000&tenantId=3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
	homeUrl: 'https://testtools.scania.com',
	wikiUrl: 'https://confluence.collaborationlayer-traton.com/spaces/TW/pages/413008581/12+Analyzer',
	blogAndNewsUrl: 'https://testtools.scania.com/blogs-news?label=analyzer',
};
